import { Realtime } from 'ably'

export default ({ $config }, inject) ->
  # Create a new realtime connection and inject it into the app
  inject 'realtime', new Realtime($config.ablyToken)
